import { useContext } from 'react';

import { FieldArrayContext } from '../fieldArrayContext';

import type { FieldArrayContextState } from '../fieldArrayContext';

export const useFormFieldArray = (): FieldArrayContextState => useContext( FieldArrayContext );
